<template>
  <div class="cart-products seccion-gris">
    <section>
      <CartBreadcumbs :stepActive="2" />
      <StoreWithdrawal
        :selectedDelivery="selectedDelivery"
        :deliveryDay="deliveryDay"
        :storeSchedule="storeSchedule"
      />
      <HomeDelivery
        :selectedAddress="selectedAddress"
        :selectedAddressDesc="selectedAddressDesc"
        :selectedDelivery="selectedDelivery"
        :totalValue="totalValue"
        :selectedAddressDistrict="selectedAddressDistrict"
      />
      <HomeDeliveryOtherPlaces
        :key="otherPlacesComponentKey"
        :selectedAddressDesc="selectedAddressDesc"
        :totalValue="totalValue"
      />
      <div class="container cart-container">
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <h2>
              Tus Datos: <strong>{{ clientName + ' ' + clientLastName }}</strong>
            </h2>
            <div class="hrdivider"><hr /></div>
            <div class="row">
              <form @submit.prevent="updateAccount">
                <div class="col-lg-12">
                  <div class="row" style="padding-bottom: 0px;">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-4 form-col">
                            <label for="firstName" class="control-label">Nombre *: </label>
                          </div>
                          <div class="col-sm-8">
                            <input
                              type="text"
                              id="firstName"
                              v-model="clientName"
                              placeholder="Nombre*"
                              maxlength="24"
                              minlength="2"
                              required="required"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-4 form-col">
                            <label for="lastName" class="control-label">Apellido *: </label>
                          </div>
                          <div class="col-sm-8">
                            <input
                              type="text"
                              id="lastName"
                              v-model="clientLastName"
                              placeholder="Apellido*"
                              maxlength="24"
                              minlength="2"
                              required="required"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-4 form-col">
                            <label for="lastName" class="control-label">DNI *: </label>
                          </div>
                          <div class="col-sm-8">
                            <input
                              type="text"
                              v-model="clientDni"
                              required="required"
                              id="dni"
                              placeholder="DNI"
                              maxlength="8"
                              pattern="[0-9]{8}"
                              title="Sólo se permiten números. Debe ingresar un DNI válido."
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-4 form-col">
                            <label for="lastName" class="control-label">Teléfono *: </label>
                          </div>
                          <div class="col-sm-8">
                            <input
                              type="text"
                              v-model="clientPhone"
                              id="phone"
                              placeholder="Teléfono"
                              maxlength="11"
                              pattern="[0-9]{7,11}"
                              title="Sólo se permiten números. Debe ingresar un teléfono válido."
                              required="required"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <button type="submit" class="btn btn-primary btn-actualizar">
                        Actualizar mis datos
                      </button>
                    </div>
                    <div class="col" style="padding-top:10px;">
                      <div
                        :class="[successMessage === '' ? 'd-none' : 'alert alert-success']"
                        role="alert"
                      >
                        <button type="button" class="close" data-dismiss="alert">&times;</button
                        ><strong>{{ successMessage }}</strong>
                      </div>
                      <div
                        :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']"
                        role="alert"
                      >
                        <button type="button" class="close" data-dismiss="alert">&times;</button
                        ><strong>{{ errorMessage }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <ClientAddressList v-if="configData.ecommerceProps.isSendToHomeAvailable" />
            </div>
          </div>
          <div class="card col-sm-12 col-md-4" style="height: auto;">
            <br />
            <h5><strong>Seleccione su Método de Entrega</strong></h5>
            <br />
            <div class="row" v-if="configData.ecommerceProps.isSendToHomeAvailable">
              <template v-if="selectedAddress != '' && isSelectedDeliveryAreInMainCity == false">
                <div class="col-sm-12">
                  <button
                    data-toggle="modal"
                    data-target="#provincia"
                    class="btn btn-al btn-al-lg btn-light button-iff"
                    style="width: 100%;"
                  >
                    <i class="fa fa-truck"></i><br /><small>Despacho A Domicilio</small>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="col-sm-12">
                  <button
                    data-toggle="modal"
                    data-target="#domicilio"
                    class="btn btn-al btn-al-lg btn-light button-iff"
                    style="width: 100%;"
                  >
                    <i class="fa fa-truck"></i><br /><small>Despacho A Domicilio</small>
                  </button>
                </div>
              </template>
            </div>
            <div class="row mt-3">
              <div class="col-sm-12">
                <button
                  data-toggle="modal"
                  data-target="#retiro"
                  class="btn btn-al btn-al-lg btn-light button-iff"
                  style="width: 100%;"
                >
                  <i class="fa fa-shopping-bag"></i><br /><small>Retiro en tienda</small>
                </button>
              </div>
              <div class="col-sm-12" v-if="isSelectedDelivery">
                <br />
                <strong>DETALLES DE ENTREGA:</strong>
                <p style="text-align: left;">
                  <small
                    ><strong>Tipo de entrega:</strong> {{ deliveryType }}<br />
                    <template v-if="agencyTransportAddressDesc != ''">
                      <strong>Dirección de destino: </strong>
                    </template>
                    <template v-else>
                      <strong>Lugar de Entrega: </strong>
                    </template>
                    <span v-html="selectedDelivery"></span>
                    <template v-if="agencyTransportAddressDesc != ''">
                      <br />
                      <strong>Lugar de entrega (Agencia de Transporte): </strong>
                      <span v-html="agencyTransportAddressDesc"></span>
                    </template>
                    <br />
                    <strong>Fecha de despacho:</strong> {{ deliveryDay | esDate }}
                    <br />
                    <strong>Costo de entrega:</strong> {{ deliveryCost | currency }}</small
                  >
                </p>
                <template v-if="agencyTransportAddressDesc != ''">
                  <br />
                  <small
                    >La empresa garantiza el despacho hasta la agencia de transporte. La entrega de
                    su pedido desde la agencia de transporte hasta su dirección de destino es
                    responsabilidad del cliente.</small
                  >
                </template>
              </div>
            </div>
            <div class="row text-center">
              <div class="container mb-4">
                <template
                  v-if="(initialDniData === '' || initialPhoneData === '') && !updateClientData"
                >
                  <br />
                  <p style="color:red"><strong>Debe actualizar sus Datos para continuar</strong></p>
                  <a class="btn btn-primary mt-2 text-white disabled" style="width: 100%;"
                    >Pagar Productos</a
                  >
                </template>
                <template v-else-if="!isSelectedDelivery">
                  <br />
                  <p style="color:red">
                    <strong>Debe seleccionar un método de despacho</strong>
                  </p>
                  <a class="btn btn-primary mt-2 text-white disabled" style="width: 100%;"
                    >Pagar Productos</a
                  >
                </template>
                <template v-else>
                  <router-link
                    :to="'/resumen'"
                    class="btn btn-primary mt-2 text-white"
                    style="width: 100%;"
                    >Pagar Productos</router-link
                  >
                </template>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import axios from 'axios';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import CartBreadcumbs from '@/components/products/cart/components/CartBreadcumbs.vue';
import NewClientAddressClient from '@/components/products/cart/CartProductsStepTwo/components/NewClientAddressClient';
import ClientAddressList from '@/components/products/cart/CartProductsStepTwo/components/ClientAddressList';
import StoreWithdrawal from '@/components/products/cart/CartProductsStepTwo/components/StoreWithdrawal';
import HomeDelivery from '@/components/products/cart/CartProductsStepTwo/components/HomeDelivery';
import HomeDeliveryOtherPlaces from '@/components/products/cart/CartProductsStepTwo/components/HomeDeliveryOtherPlaces';
import Vue from 'vue';
import toastr from 'toastr';
import { putAccountDataFromSale, postLogin, getProfileData } from '@/service/account.service.js';
import { getCompleteLocation } from '@/service/locations.service.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import { config_settings } from '@/config.js';
import { NOT_FOUND, BAD_REQUEST, CONFLICT, UNAUTHORIZED } from '@/types/httpd.constants';
import { generateRefreshTokenBodyRequest, getAccessToken } from '@/helpers/localStorage.helpers';
import '@/components/products/cart/CartStyles.scss';

export default {
  name: 'CartProductsStepTwo',
  created() {
    this.scrollToTop();
    this.getUserData();
    this.analizeCart();
  },
  props: ['configData'],
  data() {
    return {
      successMessage: '',
      errorMessage: '',
      showLoader: false,
      clientEmail: '',
      clientUsername: '',
      clientName: '',
      clientLastName: '',
      clientDni: '',
      clientPhone: '',
      clientDistrict: '',
      clientAddress: '',
      selectedAddress: '',
      selectedAddressDesc: '',
      selectedAddressDistrict: '',
      updateClientData: false,
      deliveryType: '',
      selectedDelivery: '',
      selectedDeliveryPrefix: '',
      deliveryCost: '',
      deliveryDay: '',
      isSelectedDelivery: false,
      isSelectedDeliveryAreInMainCity: false,
      agencyTransportAddressDesc: '',
      totalValue: 0.0,
      storeSchedule: '',
      initialDniData: '',
      initialPhoneData: '',
      clientAddressData: null,
      otherPlacesComponentKey: 1,
    };
  },
  components: {
    CartBreadcumbs,
    ClientAddressList,
    NewClientAddressClient,
    StoreWithdrawal,
    HomeDelivery,
    HomeDeliveryOtherPlaces,
    GoToTrackingModule,
    GuideModule,
  },
  computed: mapState(['cartProducts']),
  methods: {
    analizeCart() {
      let actual_total = 0;
      this.cartProducts.forEach((product, index) => {
        var subtotal = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
      });
      this.totalValue = actual_total;
    },

    selectDelivery(
      deliveryId,
      deliveryType,
      selectedDelivery,
      deliveryCost,
      deliveryDay,
      storeSchedule,
    ) {
      this.agencyTransportAddressDesc = '';
      this.deliveryType = deliveryType;
      this.storeSchedule = storeSchedule;
      if (this.deliveryType == 'Retiro en tienda') {
        this.selectedDelivery = selectedDelivery;
      } else {
        this.selectedDelivery = this.selectedDeliveryPrefix + ', ' + selectedDelivery;
      }

      this.deliveryCost = deliveryCost;
      this.deliveryDay = deliveryDay;
      this.isSelectedDelivery = true;
      var json_despacho = {
        id_delivery: deliveryId,
        day_delivery: deliveryDay,
        price_delivery: deliveryCost,
      };
      localStorage.setItem('id_delivery', deliveryId);
      localStorage.setItem('day_delivery', deliveryDay);
      localStorage.setItem('price_delivery', deliveryCost);
      localStorage.setItem('dir_agency', '');
      localStorage.setItem('ruc_agency', '');
    },

    selectDeliveryOtherPlaces(
      deliveryId,
      deliveryType,
      selectedDelivery,
      deliveryCost,
      deliveryDay,
    ) {
      var direccion_embarque = JSON.parse(localStorage.getItem('transport_address_details'));
      var ruc_transporte = JSON.parse(localStorage.getItem('transport_ruc'));
      var string_direccion = direccion_embarque.erp_code;
      this.deliveryType = deliveryType;
      this.selectedDelivery = this.selectedDeliveryPrefix + ', ' + selectedDelivery;
      this.deliveryCost = deliveryCost;
      this.deliveryDay = deliveryDay;
      this.agencyTransportAddressDesc =
        'LIMA, LIMA, ' +
        direccion_embarque.id_district.desc_district +
        ', ' +
        direccion_embarque.address;
      this.isSelectedDelivery = true;
      var json_despacho = {
        id_delivery: deliveryId,
        day_delivery: deliveryDay,
        price_delivery: deliveryCost,
        dir_agency: string_direccion,
        ruc_agency: ruc_transporte,
      };
      localStorage.setItem('id_delivery', deliveryId);
      localStorage.setItem('day_delivery', deliveryDay);
      localStorage.setItem('price_delivery', deliveryCost);
      localStorage.setItem('dir_agency', string_direccion);
      localStorage.setItem('ruc_agency', ruc_transporte);
      this.otherPlacesComponentKey = this.otherPlacesComponentKey + 1;
    },

    select_address(address) {
      this.selectedAddress = address.id_address;
      this.selectedAddressDesc = address.address;
      this.selectedAddressDistrict = address.id_district.id_district;
      this.callStringUbigeo(address.id_district.id_district);
      var json_address = address;
      localStorage.setItem('address_details', JSON.stringify(json_address));
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    getUserData() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.clientEmail = response.data.email_client;
          this.clientUsername = response.data.nick_client;
          this.clientName = response.data.name_client;
          this.clientLastName = response.data.surname_client;
          this.clientDni = response.data.dni_client === null ? '' : response.data.dni_client;
          this.initialDniData = this.clientDni;
          this.clientPhone = response.data.phone_client === null ? '' : response.data.phone_client;
          this.initialPhoneData = this.clientPhone;
          this.clientAddress = response.data.address_client;
          var clientDistrict = response.data.id_district.id_district;
          if (clientDistrict != 0) {
            this.clientDistrict = response.data.id_district.id_district;
          } else {
            this.clientDistrict = '';
          }
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getUserData();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión para realizar su compra', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.errorMessage = 'Debe iniciar sesión para realizar su compra';
                this.successMessage = '';
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    async callStringUbigeo(idDistrict) {
      let response = await getCompleteLocation(idDistrict);
      if (response.data.province.id_province == 127) {
        this.isSelectedDeliveryAreInMainCity = true;
      } else {
        this.isSelectedDeliveryAreInMainCity = false;
      }
      var respuesta =
        response.data.departament.desc_departament +
        ', ' +
        response.data.province.desc_province +
        ', ' +
        response.data.district.desc_district +
        ', ';
      this.selectedDeliveryPrefix = respuesta;
    },

    setAddressDetailsData(address) {
      this.clientAddressData = address;
    },

    updateAccount() {
      this.updateClientData = false;
      this.showLoader = true;
      var distrito_json = '';
      var direccion_json = ' ';
      var dni_json = ' ';
      var phone_json = ' ';
      this.clientDistrict != ''
        ? (distrito_json = { id_district: this.clientDistrict })
        : (distrito_json = { id_district: null });
      this.clientAddress != '' ? (direccion_json = this.clientAddress) : (direccion_json = ' ');
      this.clientDni != '' ? (dni_json = this.clientDni) : (dni_json = null);
      this.clientPhone != '' ? (phone_json = this.clientPhone) : (phone_json = null);
      var jsonObject = {
        nick_client: this.clientUsername,
        dni_client: dni_json,
        name_client: this.clientName,
        surname_client: this.clientLastName,
        address_client: direccion_json,
        email_client: this.clientEmail,
        phone_client: phone_json,
        id_district: distrito_json,
        state: {
          id_state: 1,
        },
      };
      putAccountDataFromSale(jsonObject, getAccessToken())
        .then((response) => {
          this.successMessage = 'Sus datos se actualizaron correctamente';
          this.errorMessage = '';
          this.updateClientData = true;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.updateAccount();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '/inicio' });
              });
          } else if (error.response.status === CONFLICT) {
            this.errorMessage =
              'El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.';
          } else if (error.response.status === BAD_REQUEST) {
            this.errorMessage = 'Ingrese correctamente los datos solicitados.';
          } else {
            this.errorMessage = 'Se ha producido un error. Inténtelo nuevamente.';
          }
          this.successMessage = '';
        });
      this.showLoader = false;
    },
  },
};
</script>
